export default class Locale_WorkPackages { 
	CreateNewPackage: string = "Create new template";
	SelectPackageForEdit: string = "Select template for edit";
}